import { ChannelState } from './types'

export const initialConfigState: ChannelState = {
	CODE: '',
	FILE_ID: ''
}
